import React, { useState } from 'react';
import { message } from 'antd';
import './login.css';

const DkjAiLogo: React.FC = () => (
  <svg width="128" height="32" viewBox="0 0 128 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16 0C24.832 0 32 7.168 32 16C32 24.832 24.832 32 16 32C7.168 32 0 24.832 0 16C0 7.168 7.168 0 16 0ZM16 28.8C23.072 28.8 28.8 23.072 28.8 16C28.8 8.928 23.072 3.2 16 3.2C8.928 3.2 3.2 8.928 3.2 16C3.2 23.072 8.928 28.8 16 28.8ZM21.6576 8.08L23.92 10.3424L16 18.2624L13.7376 16L21.6576 8.08Z"
      fill="#0E1F27"
    />
    <path
      d="M120.541 26.3985V8.78445H123.918V26.3985H120.541ZM116.634 26.3985V23.5842H127.163V26.3985H116.634ZM116.634 11.5987V8.78445H123.62V11.5987H116.634ZM120.342 6.23506V2.75861H123.786V6.23506H120.342Z"
      fill="#0E1F27"
    />
    <path
      d="M103.587 26.9904C102.483 26.9904 101.49 26.7918 100.607 26.3944C99.7241 25.9971 99.0178 25.4343 98.4881 24.7059C97.9804 23.9775 97.7266 23.1277 97.7266 22.1565C97.7266 20.6556 98.1791 19.4857 99.084 18.6469C100.011 17.8082 101.402 17.2122 103.256 16.859L108.951 15.6671C108.951 14.2986 108.653 13.2722 108.057 12.588C107.461 11.9037 106.567 11.5616 105.375 11.5616C104.271 11.5616 103.41 11.8154 102.792 12.3231C102.174 12.8308 101.755 13.5371 101.534 14.4421L98.0245 14.2103C98.3556 12.5328 99.1613 11.1753 100.442 10.1379C101.722 9.1005 103.366 8.58179 105.375 8.58179C107.626 8.58179 109.337 9.2219 110.507 10.5021C111.699 11.7823 112.295 13.5481 112.295 15.7996V22.7525C112.295 23.1498 112.383 23.4367 112.559 23.6133C112.736 23.7678 112.99 23.8451 113.321 23.8451H114.314V26.5931C114.182 26.6152 113.961 26.6372 113.652 26.6593C113.365 26.6814 113.078 26.6924 112.791 26.6924C111.997 26.6924 111.323 26.56 110.772 26.2951C110.22 26.0302 109.8 25.6219 109.513 25.0701C109.249 24.4962 109.094 23.7788 109.05 22.918H109.58C109.447 23.6905 109.105 24.3858 108.553 25.0039C108.001 25.6219 107.295 26.1075 106.434 26.4607C105.573 26.8138 104.624 26.9904 103.587 26.9904ZM104.083 24.2424C105.143 24.2424 106.037 24.0547 106.765 23.6795C107.494 23.3043 108.035 22.7745 108.388 22.0903C108.763 21.406 108.951 20.6004 108.951 19.6733V18.3158L104.05 19.3091C102.991 19.5078 102.251 19.8168 101.832 20.2362C101.413 20.6556 101.203 21.2074 101.203 21.8916C101.203 22.62 101.457 23.1939 101.965 23.6133C102.472 24.0327 103.179 24.2424 104.083 24.2424Z"
      fill="#0E1F27"
    />
    <path d="M88.8281 26.5931V22.2227H93.331V26.5931H88.8281Z" fill="#0E1F27" />
    <path
      d="M76.4287 31.5595V28.7453H78.482C79.387 28.7453 80.0492 28.5466 80.4686 28.1493C80.91 27.752 81.1308 27.0236 81.1308 25.9641V8.97915H84.5079V26.1627C84.5079 27.9065 84.0443 29.2419 83.1173 30.1689C82.2123 31.096 80.7886 31.5595 78.8462 31.5595H76.4287ZM76.6936 11.7934V8.97915H82.9518V11.7934H76.6936ZM81.0314 6.42976V2.95331H84.4748V6.42976H81.0314Z"
      fill="#0E1F27"
    />
    <path
      d="M58.3633 26.5931V3.08569H61.7073V17.8523L69.6535 8.9791H73.9245L67.0378 16.4617L74.2225 26.5931H70.2825L64.8195 18.7132L61.7073 21.991V26.5931H58.3633Z"
      fill="#0E1F27"
    />
    <path
      d="M44.4055 26.9904C42.9046 26.9904 41.6023 26.6262 40.4987 25.8978C34.5911 21.8807 36.5455 9.90593 44.4055 9.90593C45.6416 9.90593 46.7232 10.1929 47.6502 10.7668C48.5773 11.3407 49.2505 12.0139 49.6699 12.7864V3.08569H53.0139V26.5931H49.9016L49.8023 23.8782C48.7532 25.9287 46.6633 26.9904 44.4055 26.9904ZM44.9684 23.9113C46.8665 23.9113 48.3554 22.7968 49.0739 21.0639C50.4708 17.8045 49.0202 12.9851 44.9022 12.9851C42.3446 12.9851 40.5649 15.392 40.5649 17.7861C40.5649 20.5796 41.6602 23.9113 44.9684 23.9113Z"
      fill="#0E1F27"
    />
  </svg>
);

const ArrowRightIcon: React.FC = () => (
  <svg width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.7806 8.03104L11.0306 14.781C10.8899 14.9218 10.699 15.0008 10.5 15.0008C10.301 15.0008 10.1101 14.9218 9.96937 14.781C9.82864 14.6403 9.74958 14.4494 9.74958 14.2504C9.74958 14.0514 9.82864 13.8605 9.96937 13.7198L15.4397 8.25042H0.75C0.551088 8.25042 0.360322 8.1714 0.21967 8.03075C0.0790178 7.8901 0 7.69933 0 7.50042C0 7.3015 0.0790178 7.11074 0.21967 6.97009C0.360322 6.82943 0.551088 6.75042 0.75 6.75042H15.4397L9.96937 1.28104C9.82864 1.14031 9.74958 0.94944 9.74958 0.750417C9.74958 0.551394 9.82864 0.360523 9.96937 0.219792C10.1101 0.0790615 10.301 0 10.5 0C10.699 0 10.8899 0.0790615 11.0306 0.219792L17.7806 6.96979C17.8504 7.03945 17.9057 7.12216 17.9434 7.21321C17.9812 7.30426 18.0006 7.40186 18.0006 7.50042C18.0006 7.59898 17.9812 7.69657 17.9434 7.78762C17.9057 7.87867 17.8504 7.96139 17.7806 8.03104Z"
      fill="white"
    />
  </svg>
);

const LoginPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    if (!email.trim()) {
      message.error('Please enter your email.');
      return;
    }
    setLoading(true);
    try {
      const response = await fetch(
        'https://z7addc12sl.execute-api.us-east-2.amazonaws.com/v1/dkj/User/OTPSendCode',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            Email: email,
          }),
        }
      );
      const data = await response.json();
      if (response.ok) {
        if (data.status === "1") {
          message.success('Email sent successfully. Please check your inbox to log in.');
        } else {
          message.error(data.message);
        }
      } else {
        message.error('Failed to send email. Please try again.');
      }
    } catch (error) {
      console.error('Error:', error);
      message.error('Network error. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
  };

  return (
    <div className="loginPage">
      <div className="loginLogo" aria-label="dkj.ai">
        <DkjAiLogo />
      </div>

      <div className="loginContent">
        <h1 className="loginTitle">Let's sign you in!</h1>

        <div className="loginPill">
          <input
            className="loginInput"
            placeholder="Enter your email"
            value={email}
            onChange={handleInputChange}
            type="email"
            autoComplete="email"
          />

          <button
            className="loginButton"
            type="button"
            onClick={handleLogin}
            disabled={loading || !email.trim()}
          >
            <span className="loginButtonText">{loading ? 'Sending...' : 'Continue'}</span>
            <span className="loginButtonIcon" aria-hidden="true">
              <ArrowRightIcon />
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
